import { render, staticRenderFns } from "./baseInfomation.vue?vue&type=template&id=38fd191a&scoped=true"
import script from "./baseInfomation.vue?vue&type=script&lang=js"
export * from "./baseInfomation.vue?vue&type=script&lang=js"
import style0 from "./baseInfomation.vue?vue&type=style&index=0&id=38fd191a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd191a",
  null
  
)

export default component.exports